// extracted by mini-css-extract-plugin
export default {"dnb_menuBottomBar":"MenuBottomBar-module--dnb_menuBottomBar--ZwY1u","link":"MenuBottomBar-module--link--frg68"};